var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { CommonUserProfileStore } from '@gh/common-shared';
import { EMPTY_ID } from '@gh/common-shared-data';
import { DEFAULT_LOCALE } from '@gh/config';
import { Locale } from '@gh/core-mls';
import { SupplierUserProfileRestService } from '@gh/supplier-shared-data';
import * as i0 from "@angular/core";
import * as i1 from "@gh/supplier-shared-data";
function supplierUserDataFromDto(dto) {
    return {
        backendBuildNumber: '',
        firstName: '',
        lastName: '',
        id: EMPTY_ID,
        locale: Locale.createFromStandard(DEFAULT_LOCALE),
        fullName: '',
        zoneId: '',
        login: dto.email,
        receiveEmails: dto.receiveEmails,
    };
}
var SupplierUserProfileStore = /** @class */ (function (_super) {
    __extends(SupplierUserProfileStore, _super);
    function SupplierUserProfileStore(userProfileRest) {
        var _this = _super.call(this) || this;
        _this.userProfileRest = userProfileRest;
        return _this;
    }
    SupplierUserProfileStore.prototype.load = function (params) {
        var _this = this;
        this.userProfileRest.get()
            .subscribe(function (user) { return _this.setLoggedInUser(supplierUserDataFromDto(user)); }, function (error) { return _this.setLoginError(error); });
    };
    SupplierUserProfileStore.prototype.logout = function () {
        var _this = this;
        this.userProfileRest.logout()
            .subscribe(function () { return _this.setLoggedOut(); });
    };
    SupplierUserProfileStore.prototype.updateLocale = function (locale) {
        throw new Error('Customer Portal does not support changing of locale');
    };
    SupplierUserProfileStore.prototype.updateReceiveEmails = function (receiveEmails) {
        var _this = this;
        this.userProfileRest.update({ receiveEmails: receiveEmails })
            .subscribe(function (user) { return _this.setLoggedInUser(supplierUserDataFromDto(user)); });
    };
    SupplierUserProfileStore.ɵfac = function SupplierUserProfileStore_Factory(t) { return new (t || SupplierUserProfileStore)(i0.ɵɵinject(i1.SupplierUserProfileRestService)); };
    SupplierUserProfileStore.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierUserProfileStore, factory: SupplierUserProfileStore.ɵfac });
    return SupplierUserProfileStore;
}(CommonUserProfileStore));
export { SupplierUserProfileStore };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierUserProfileStore, [{
        type: Injectable
    }], function () { return [{ type: i1.SupplierUserProfileRestService }]; }, null); })();
